

"use strict";
import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { DIALOG_AUX_FUNCTIONS } from "../util/classes";
import { Whisper } from "../util/classes";
import { UTL } from "../util/classes";

/**
 * DIALOG4 Static Class
 * מחלקה סטטית לניהול דיאלוג בחירה בוליאנית (True/False)
 */
export class DIALOG4 {
    // --- Components (Static Properties) ---
    public static overlay_element: HTMLElement = null; // must be public because called from outslde
    private static popup_element: HTMLElement = null;
    private static caption_element: HTMLElement = null;
    private static case_element: HTMLElement = null;
    private static select_false_element: HTMLElement = null;
    private static select_true_element: HTMLElement = null;
    private static close_button_element: HTMLSpanElement = null;
    private static defo_button_element: HTMLSpanElement = null;
    private static panel_element: HTMLElement = null;
    private static ok_button_element: HTMLElement = null;
    private static cancel_button_element: HTMLElement = null;
    private static erase_button_element: HTMLElement = null;

    // --- State Variables ---
    private static MD_FLAG: boolean = false;
    private static defo_button_is_clicked: boolean = false;
    private static Vamod_MouseX: number = 0;
    private static Vamod_MouseY: number = 0;
    private static Vamod_ModalWindowLeftX: number = 0;
    private static Vamod_ModalWindowTopY: number = 0;

    private static par_callback_function: Function = null;
    private static par_input_OBJ: oBool = null;
    private static par_wisper: Whisper = null;

    //-----------------------------------------------------------------------------------------
    // משמעות המילה static כאן היא שמטרתו של המשתנה להישמר בין הפעלה להפעלה של ה-dialog
    //-----------------------------------------------------------------------------------------
    private static var_bool_content: boolean = false;
    private static static_bool_content: boolean = false;
    //-----------------------------------------------------------------------------------------

    private static readonly BID = {
        UNDEFINED: 0,
        OK: 1,
        CANCEL: 2,
        ERASE: 3
    };

    private static var_current_pseudo_focused_btn: number = DIALOG4.BID.OK;

    // --- Methods ---

    public static refresh_pseudo_focus_for_all_buttons(): void {
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG4.ok_button_element, DIALOG4.var_current_pseudo_focused_btn == DIALOG4.BID.OK);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG4.cancel_button_element, DIALOG4.var_current_pseudo_focused_btn == DIALOG4.BID.CANCEL);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG4.erase_button_element, DIALOG4.var_current_pseudo_focused_btn == DIALOG4.BID.ERASE);
    }

    public static respond_tab(): void {
        DIALOG4.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Forward(DIALOG4.var_current_pseudo_focused_btn, DIALOG4.BID.OK, DIALOG4.BID.ERASE);
        DIALOG4.refresh_pseudo_focus_for_all_buttons();
    }

    public static respond_shift_tab(): void {
        DIALOG4.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Backward(DIALOG4.var_current_pseudo_focused_btn, DIALOG4.BID.OK, DIALOG4.BID.ERASE);
        DIALOG4.refresh_pseudo_focus_for_all_buttons();
    }

    private static create_overlay_element(): HTMLElement {
        const overlay_element = document.createElement("div");
        overlay_element.style.position = "fixed";
        overlay_element.style.top = "0";
        overlay_element.style.left = "0";
        overlay_element.style.width = "100%";
        overlay_element.style.height = "100%";
        overlay_element.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
        overlay_element.style.zIndex = "1000";
        return overlay_element;
    }

    private static create_popup_element(): HTMLElement {
        const popup_element = document.createElement("div");
        popup_element.id = "id-DIALOG4-popup";
        popup_element.style.position = "absolute";
        popup_element.style.backgroundColor = "#fff";
        popup_element.style.padding = "0px";
        popup_element.style.borderRadius = "8px";
        popup_element.style.width = "320px";
        popup_element.style.textAlign = "center";
        return popup_element;
    }

    private static create_caption_element(): HTMLElement {
        const caption = document.createElement("div");
        caption.textContent = "DIALOG4";
        caption.style.fontSize = "24px";
        caption.style.fontWeight = "bold";
        caption.style.margin = "0px";
        caption.style.padding = "0px";
        caption.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_caption_backgroundColor();
        caption.style.color = DIALOG_AUX_FUNCTIONS.get_caption_forgroundColor();
        caption.style.borderTopLeftRadius = "5px";
        caption.style.borderTopRightRadius = "5px";
        caption.style.userSelect = "none";
        return caption;
    }

    private static create_close_button(): HTMLSpanElement {
        return DIALOG_AUX_FUNCTIONS.create_close_button_element();
    }

    private static create_defo_button(): HTMLSpanElement {
        return DIALOG_AUX_FUNCTIONS.create_defo_button_element();
    }

    private static create_case_element(): HTMLElement {
        const element = document.createElement("div");
        element.id = "id-DIALOG4-case";
        element.style.backgroundColor = "yellow";
        element.style.width = "100px";
        element.style.padding = "2px";
        element.style.margin = "auto";
        return element;
    }

    private static create_select_false_element(): HTMLElement {
        const element = document.createElement("div");
        element.style.backgroundColor = "green";
        element.style.fontSize = "26px";
        element.style.margin = "1px";
        element.textContent = "false";
        element.style.userSelect = "none";
        return element;
    }

    private static create_select_true_element(): HTMLElement {
        const element = document.createElement("div");
        element.style.backgroundColor = "green";
        element.style.fontSize = "26px";
        element.style.margin = "1px";
        element.textContent = "true";
        element.style.userSelect = "none";
        return element;
    }

    private static create_panel_element(): HTMLElement {
        const buttonsContainer = document.createElement("div");
        buttonsContainer.style.marginTop = "15px";
        buttonsContainer.style.display = "flex";
        buttonsContainer.style.justifyContent = "space-around";
        buttonsContainer.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_panel_backgroundColor();
        buttonsContainer.style.marginBottom = "7px";
        return buttonsContainer;
    }

    private static create_ok_button_element(): HTMLElement {
        return DIALOG_AUX_FUNCTIONS.create_ok_button_element();
    }

    private static create_cancel_button_element(): HTMLElement {
        return DIALOG_AUX_FUNCTIONS.create_cancel_button_element();
    }

    private static create_erase_button_element(): HTMLElement {
        return DIALOG_AUX_FUNCTIONS.create_erase_button_element();
    }

    public static overlay_mousedown(event: MouseEvent): void {
        const target_element = event.target as HTMLElement;
        if (target_element == DIALOG4.caption_element) {
            const popup_element_bounding_rect: DOMRect = DIALOG4.popup_element.getBoundingClientRect();
            DIALOG4.MD_FLAG = true;
            DIALOG4.Vamod_MouseX = event.clientX;
            DIALOG4.Vamod_MouseY = event.clientY;
            DIALOG4.Vamod_ModalWindowLeftX = popup_element_bounding_rect.left; // אבל כנראה זה היה טעות parseFloat במקור היה כאן 
            DIALOG4.Vamod_ModalWindowTopY = popup_element_bounding_rect.top; // אבל כנראה זה היה טעות parseFloat במקור היה כאן 
        }
        if (target_element == DIALOG4.defo_button_element) {
            DIALOG4.defo_button_is_clicked = true;
        }
    }

    public static overlay_mousemove(event: MouseEvent): void {
        if (DIALOG4.MD_FLAG == true) {
            const delta_x = event.clientX - DIALOG4.Vamod_MouseX;
            const delta_y = event.clientY - DIALOG4.Vamod_MouseY;
            DIALOG4.popup_element.style.left = (DIALOG4.Vamod_ModalWindowLeftX + delta_x) + "px";
            DIALOG4.popup_element.style.top = (DIALOG4.Vamod_ModalWindowTopY + delta_y) + "px";
        }
    }

    public static overlay_mouseup(event: MouseEvent): void {
        const freezed_defo_button_is_clicked = DIALOG4.defo_button_is_clicked;
        DIALOG4.MD_FLAG = false;
        DIALOG4.defo_button_is_clicked = false;
        if (freezed_defo_button_is_clicked == false) {
            DIALOG4.case_element.focus();
        }
    }

    public static xor_var_bool_content_no_refresh(): void {
        DIALOG4.var_bool_content = !DIALOG4.var_bool_content;
    }

    public static event_key_is_one_of_4_arrows(p_key: string): boolean {
        return (p_key === 'ArrowUp' || p_key === 'ArrowDown' || p_key === 'ArrowLeft' || p_key === 'ArrowRight');
    }

    public static perform_pseudo_focused_button(): void {
        if (DIALOG4.var_current_pseudo_focused_btn == DIALOG4.BID.OK) {
            DIALOG4.perform_ok();
        }
        if (DIALOG4.var_current_pseudo_focused_btn == DIALOG4.BID.CANCEL) {
            DIALOG4.perform_cancel();
        }
        if (DIALOG4.var_current_pseudo_focused_btn == DIALOG4.BID.ERASE) {
            DIALOG4.perform_erase();
        }
    }

    public static overlay_keydown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            DIALOG4.perform_pseudo_focused_button();
        }
        if (event.key === 'Escape') {
            DIALOG4.perform_cancel();
        }
        if (DIALOG4.event_key_is_one_of_4_arrows(event.key)) {
            event.preventDefault();
            DIALOG4.xor_var_bool_content_no_refresh();
            DIALOG4.refresh_colors_in_select_elements();
        }
        if (event.key === 'Tab') {
            event.preventDefault();
            if (event.shiftKey == false) DIALOG4.respond_tab();
            if (event.shiftKey == true) DIALOG4.respond_shift_tab();
        }
    }

    public static create_result_OBJ(p_value_exist: boolean, p_value_conent: boolean): oBool {
        const CONSTRUCTIOR = Object.getPrototypeOf(DIALOG4.par_input_OBJ).constructor;
        if (CONSTRUCTIOR === oBool) {
            return new oBool(p_value_exist, p_value_conent);
        }
        alert("DIALOG4.error unknown object");
    }

    public static call_callback(p_change_flag: boolean, p_value_exist: boolean, p_value_conent: boolean): void {
        if (DIALOG4.par_callback_function != null) {
            document.body.removeChild(DIALOG4.overlay_element);
            const delay_in_milliseconds = 0;
            let OBJ = DIALOG4.create_result_OBJ(p_value_exist, p_value_conent);

            // refresh כדי שיתבצע setTimeout() אנחנו משתמשים ב
            setTimeout(DIALOG4.par_callback_function, delay_in_milliseconds, p_change_flag, OBJ);
        }
        else {
            alert("DIALOG4_callback_function != null");
        }
    }

    public static perform_ok(): void {
        const change_flag = true;
        const value_exist = true;
        const value_content = DIALOG4.var_bool_content;
        DIALOG4.static_bool_content = DIALOG4.var_bool_content;
        DIALOG4.call_callback(change_flag, value_exist, value_content);
    }

    public static perform_cancel(): void {
        const change_flag = false;
        const value_exist = false;
        const value_content = false;
        DIALOG4.call_callback(change_flag, value_exist, value_content);
    }

    public static perform_defo(): void {
        UTL.show_which_element_has_focus();
    }

    public static perform_erase(): void {
        const change_flag = true;
        const value_exist = false;
        const value_content = false;
        DIALOG4.call_callback(change_flag, value_exist, value_content);
    }

    private static create_new_br_element(): HTMLBRElement {
        return document.createElement('br');
    }

    public static paint_colors_in_select_elements(element: HTMLElement, bval: boolean): void {
        if (bval == false) {
            element.style.backgroundColor = "white";
            element.style.color = "black";
        }
        if (bval == true) {
            element.style.backgroundColor = "blue";
            element.style.color = "white";
        }
    }

    public static refresh_colors_in_select_elements(): void {
        if (DIALOG4.var_bool_content == false) {
            DIALOG4.paint_colors_in_select_elements(DIALOG4.select_false_element, true);
            DIALOG4.paint_colors_in_select_elements(DIALOG4.select_true_element, false);
        }
        if (DIALOG4.var_bool_content == true) {
            DIALOG4.paint_colors_in_select_elements(DIALOG4.select_false_element, false);
            DIALOG4.paint_colors_in_select_elements(DIALOG4.select_true_element, true);
        }
    }

    public static select_false_element_mousedown(event: MouseEvent): void {
        DIALOG4.var_bool_content = false;
        DIALOG4.refresh_colors_in_select_elements();
    }

    public static select_true_element_mousedown(event: MouseEvent): void {
        DIALOG4.var_bool_content = true;
        DIALOG4.refresh_colors_in_select_elements();
    }

    public static create_dialog(p_callback_function: Function, p_input_OBJ: oBool, p_wisper: Whisper): void {
        DIALOG4.par_callback_function = p_callback_function;
        DIALOG4.par_input_OBJ = p_input_OBJ;

        if (true) {
            DIALOG4.var_bool_content = DIALOG4.static_bool_content;
        }
        DIALOG4.par_wisper = p_wisper;

        // Creation
        DIALOG4.overlay_element = DIALOG4.create_overlay_element();
        DIALOG4.popup_element = DIALOG4.create_popup_element();
        DIALOG4.caption_element = DIALOG4.create_caption_element();
        DIALOG4.close_button_element = DIALOG4.create_close_button();

        try {
            DIALOG4.defo_button_element = DIALOG4.create_defo_button();
        } catch (error) {
            alert(error);
        }

        DIALOG4.case_element = DIALOG4.create_case_element();
        DIALOG4.select_false_element = DIALOG4.create_select_false_element();
        DIALOG4.select_true_element = DIALOG4.create_select_true_element();

        DIALOG4.panel_element = DIALOG4.create_panel_element();
        DIALOG4.ok_button_element = DIALOG4.create_ok_button_element();
        DIALOG4.cancel_button_element = DIALOG4.create_cancel_button_element();
        DIALOG4.erase_button_element = DIALOG4.create_erase_button_element();

        // Nesting
        DIALOG4.overlay_element.appendChild(DIALOG4.popup_element);
        DIALOG4.caption_element.appendChild(DIALOG4.close_button_element);
        DIALOG4.caption_element.appendChild(DIALOG4.defo_button_element);
        DIALOG4.popup_element.appendChild(DIALOG4.caption_element);
        DIALOG4.popup_element.appendChild(DIALOG4.create_new_br_element());

        DIALOG4.popup_element.appendChild(DIALOG4.case_element);
        DIALOG4.case_element.appendChild(DIALOG4.select_false_element);
        DIALOG4.case_element.appendChild(DIALOG4.select_true_element);

        DIALOG4.popup_element.appendChild(DIALOG4.panel_element);
        DIALOG4.panel_element.appendChild(DIALOG4.ok_button_element);
        DIALOG4.panel_element.appendChild(DIALOG4.cancel_button_element);
        DIALOG4.panel_element.appendChild(DIALOG4.erase_button_element);

        // Listeners
        DIALOG4.overlay_element.addEventListener("mousedown", DIALOG4.overlay_mousedown);
        DIALOG4.overlay_element.addEventListener("mousemove", DIALOG4.overlay_mousemove);
        DIALOG4.overlay_element.addEventListener("mouseup", DIALOG4.overlay_mouseup);
        DIALOG4.overlay_element.addEventListener("keydown", DIALOG4.overlay_keydown);

        DIALOG4.defo_button_element.addEventListener("click", DIALOG4.perform_defo);
        DIALOG4.ok_button_element.addEventListener("click", DIALOG4.perform_ok);
        DIALOG4.cancel_button_element.addEventListener("click", DIALOG4.perform_cancel);
        DIALOG4.erase_button_element.addEventListener("click", DIALOG4.perform_erase);
        DIALOG4.close_button_element.addEventListener("click", DIALOG4.perform_cancel);

        DIALOG4.select_false_element.addEventListener("mousedown", DIALOG4.select_false_element_mousedown);
        DIALOG4.select_true_element.addEventListener("mousedown", DIALOG4.select_true_element_mousedown);

        // Initialization
        DIALOG4.refresh_colors_in_select_elements();
        document.body.appendChild(DIALOG4.overlay_element);
        UTL.center_popup_element_inside_overlay_element(DIALOG4.popup_element, DIALOG4.overlay_element);

        DIALOG4.var_current_pseudo_focused_btn = DIALOG4.BID.OK;
        DIALOG4.refresh_pseudo_focus_for_all_buttons();

        // focus handling
        UTL.MakeElementFocusable(DIALOG4.case_element);
        DIALOG4.case_element.focus();
    }
}